import { liquidPixelResolutionSizes } from '../../imageUtils';
import { findResolutionIndex, liquidPixelResolutionMappings, } from '../../imageUtils/urlMappings/productImageMappings';
import { cdnRegex } from './constants';
export var ImageServiceType;
(function (ImageServiceType) {
    ImageServiceType[ImageServiceType["LIQUID_PIXELS"] = 0] = "LIQUID_PIXELS";
    ImageServiceType[ImageServiceType["AKAMAI"] = 1] = "AKAMAI";
    ImageServiceType[ImageServiceType["UNKNOWN"] = 2] = "UNKNOWN";
})(ImageServiceType || (ImageServiceType = {}));
function unreachableError(value) {
    return new Error(`UnreachableError: got value ${value}`);
}
export const getImageServiceType = (url) => {
    if (url.match(cdnRegex.liquidpixel)) {
        return ImageServiceType.LIQUID_PIXELS;
    }
    if (url.match(cdnRegex.akamai)) {
        return ImageServiceType.AKAMAI;
    }
    return ImageServiceType.UNKNOWN;
};
const regexMapGroup = (txt, regex, groupName, map) => {
    const match = txt.match(regex);
    if (match && match.groups && match.groups[groupName]) {
        const originalVal = match.groups[groupName];
        const newValue = map(originalVal);
        const newTxt = txt.replace(match[0], match[0].replace(match[1], newValue));
        return newTxt;
    }
    return txt;
};
const setToHighDpi = (originalSize) => String(2 * Number(originalSize));
export const lpUrlToHighDpi = (url) => {
    const resCallRegex = /(?<Res>res\[\S\]).+&(?<Call>call=url\[\S+\])/;
    const resCallMatch = url.match(resCallRegex);
    if (resCallMatch && resCallMatch.groups) {
        const resGroup = resCallMatch.groups.Res;
        const callGroup = resCallMatch.groups.Call;
        const currentResolutionIndex = findResolutionIndex(resGroup, callGroup);
        if (currentResolutionIndex !== undefined &&
            currentResolutionIndex + 1 < liquidPixelResolutionSizes.length) {
            const nextResolution = liquidPixelResolutionSizes[currentResolutionIndex + 1];
            const [nextRes, nextCall] = liquidPixelResolutionMappings[nextResolution];
            const newUrl = url.replace(resGroup, nextRes).replace(callGroup, nextCall);
            return newUrl;
        }
        return url;
    }
    const sizeRegex = /scale=size\[(?<Size>\d+)\]/;
    return regexMapGroup(url, sizeRegex, 'Size', setToHighDpi);
};
export const akamaiUrlToHighDpi = (url) => {
    const widthRegex = /imwidth=(?<Size>\d+)/;
    const heightRegex = /imheight=(?<Size>\d+)/;
    const urlNewWidth = regexMapGroup(url, widthRegex, 'Size', setToHighDpi);
    return regexMapGroup(urlNewWidth, heightRegex, 'Size', setToHighDpi);
};
export const toHighDPIImageUrl = (url) => {
    const cdn = getImageServiceType(url);
    switch (cdn) {
        case ImageServiceType.AKAMAI:
            return akamaiUrlToHighDpi(url);
        case ImageServiceType.LIQUID_PIXELS:
            return lpUrlToHighDpi(url);
        case ImageServiceType.UNKNOWN:
            return url;
        default:
            throw unreachableError(cdn);
    }
};
//# sourceMappingURL=toHighDPIImageUrl.js.map